export class ProfiledService {

  //Singleton Class

    id: string;
    name: string;
    description: string;
    serviceCategoryId: string;
    addressLine?: string;
    city: string;
    country: string;
    state: string;
    primaryContactNumber: string;


    firstname: string;
    lastname : string;
    contact : string;
    address : string;
    email : string;

    //Login Details
     username : string;
     password : string;

     //Password Validation attribute
     confirmPassword : string;

    //Navigation Property in case a user owns a service
    serviceId : string;


}
